import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _FeedbackWrapper;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconCheckLine, IconNotGradedLine, IconXLine } from '@instructure/ui-icons';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { RichContentRenderer } from '@instructure/quiz-rce';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
export var FeedbackWrapper = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_FeedbackWrapper = /*#__PURE__*/function (_Component) {
  function FeedbackWrapper() {
    _classCallCheck(this, FeedbackWrapper);
    return _callSuper(this, FeedbackWrapper, arguments);
  }
  _inherits(FeedbackWrapper, _Component);
  return _createClass(FeedbackWrapper, [{
    key: "isCorrect",
    value: function isCorrect() {
      return this.props.status === 'correct';
    }
  }, {
    key: "renderCorrectAnswer",
    value: function renderCorrectAnswer() {
      if (this.props.richContent) {
        return jsx(RichContentRenderer, {
          customStyles: _objectSpread(_objectSpread({}, this.props.styles.correctAnswer), this.props.styles.subTitleContent),
          content: this.props.correctAnswer
        });
      }
      return jsx("span", {
        css: this.props.styles.correctAnswer
      }, jsx(Text, {
        weight: "bold",
        size: "small",
        color: "primary"
      }, this.props.correctAnswer));
    }
  }, {
    key: "renderSubTitle",
    value: function renderSubTitle() {
      var description = this.props.subTitleDescription == null ? t('Correct Answer:') : this.props.subTitleDescription;
      if (!this.isCorrect() && this.props.correctAnswer) {
        return jsx("div", {
          css: this.props.styles.correctAnswerHolder
        }, jsx("span", {
          css: this.props.styles.subTitleDescription
        }, jsx(Text, {
          wrap: "break-word",
          size: "small",
          color: "primary"
        }, description)), this.renderCorrectAnswer());
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      switch (this.props.status) {
        case 'correct':
          return jsx(IconCheckLine, null);
        case 'unknown':
          return jsx(IconNotGradedLine, null);
        case 'incorrect':
        // incorrect falls through to default
        default:
          return jsx(IconXLine, null);
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      if (this.props.children !== void 0) {
        return this.props.children;
      }
      return jsx(Text, {
        wrap: "break-word",
        color: "primary"
      }, this.props.userResponse);
    }
  }, {
    key: "render",
    value: function render() {
      var hiddenText;
      switch (this.props.status) {
        case 'correct':
          hiddenText = this.props.hiddenCorrectAnswerText;
          break;
        case 'unknown':
          break;
        case 'incorrect':
        default:
          // default to incorrect for backwards compatibility
          hiddenText = this.props.hiddenIncorrectAnswerText;
      }
      return jsx("div", {
        css: this.props.styles.root,
        className: "fs-mask"
      }, jsx("div", {
        css: this.props.styles.main
      }, jsx("div", {
        css: this.props.styles.iconHolder
      }, jsx("div", {
        css: this.props.styles.icon
      }, this.renderIcon())), jsx("div", {
        css: this.props.styles.userResponse
      }, jsx(ScreenReaderContent, {
        as: "div"
      }, hiddenText), this.renderContent())), this.renderSubTitle());
    }
  }]);
}(Component), _defineProperty(_FeedbackWrapper, "displayName", 'FeedbackWrapper'), _defineProperty(_FeedbackWrapper, "componentId", "Quizzes".concat(_FeedbackWrapper.displayName)), _defineProperty(_FeedbackWrapper, "propTypes", {
  children: PropTypes.node,
  correctAnswer: PropTypes.string,
  hiddenCorrectAnswerText: PropTypes.string,
  hiddenIncorrectAnswerText: PropTypes.string,
  status: PropTypes.oneOf(['correct', 'incorrect', 'unknown']),
  subTitleDescription: PropTypes.string,
  richContent: PropTypes.bool,
  userResponse: PropTypes.string,
  /* eslint-disable react/forbid-prop-types, react/require-default-props */
  styles: PropTypes.object
}), _defineProperty(_FeedbackWrapper, "defaultProps", {
  children: void 0,
  correctAnswer: '',
  hiddenCorrectAnswerText: '',
  hiddenIncorrectAnswerText: '',
  subTitleDescription: null,
  richContent: false,
  status: 'unknown',
  userResponse: void 0
}), _FeedbackWrapper)) || _class);
export default FeedbackWrapper;